import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Button, Grid, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

import ProgramsList from './ProgramsList';
import AdminMenus from '../AdminMenus';
import { useSelector } from 'react-redux';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ProgramDataGrid = () => {
  const [value, setValue] = React.useState(0);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const userId = user?.role_id

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="container-xxl">
        <div className="container">
           {
           userId===1? <div className='mb-3'>
              <AdminMenus buttonName='Add program' pageName='addNewProgram' />
            </div>:""
            }
            <div className='row dataTable'>
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
                    <Tab label="All Records" {...a11yProps(0)} />                    
                    </Tabs>                    
                </Box>
                <TabPanel value={value} index={0} >
                    <ProgramsList />
                </TabPanel>                
               </Paper> 
            </Box>            
            </div>
            
        </div>
    </div>
    
  );
}

export default ProgramDataGrid